import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Menu from './pages/Menu';
import FoodtruckCatering from './pages/FoodtruckCatering';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';
import ThankYou from './pages/ThankYou';
import Error404 from './pages/Error404';
import Error403 from './pages/Error403';

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-brand-cream text-brand-dark antialiased">
        {/* Navigation Header */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            
            {/* Menukort Routes */}
            <Route path="/menukort" element={<Menu />} />
            <Route path="/menukort/forretter" element={<Menu />} />
            <Route path="/menukort/hovedretter" element={<Menu />} />
            <Route path="/menukort/tilbehoer" element={<Menu />} />
            
            {/* Other Pages */}
            <Route path="/foodtruck-catering" element={<FoodtruckCatering />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/tak-for-din-henvendelse" element={<ThankYou />} />
            
            {/* Error Pages */}
            <Route path="/403" element={<Error403 />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
